import React from 'react'
import PropTypes from 'prop-types'

import DevelopmentErrorDetails from './DevelopmentErrorDetails'

export const DEFAULT_HEADER_MESSAGE =
  'Ops, detectamos um erro. Nosso time já foi notificado ;)'

export const DEVELOPMENT_ENVIRONMENTS = ['development']

export const captureException = (exception, errorInfo) => {
  // NOTE: To activate Sentry error reporting use:
  // sentryCaptureException(exception, errorInfo)
  console.error(exception, errorInfo)
}


export const isDevelopmentEnv = (env = '') => {
  const currentEnv = (env || '').toString().toLowerCase()

  return DEVELOPMENT_ENVIRONMENTS.includes(currentEnv)
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    captureException(error, errorInfo)
  }

  render() {
    const { hasError, error } = this.state

    const { children, headerMessage, env } = this.props

    const isDevelopment = isDevelopmentEnv(env)

    if (hasError) {
      return (
        <div>
          <h2>{headerMessage}</h2>
          {isDevelopment && <DevelopmentErrorDetails error={error} />}
        </div>
      )
    }

    return children
  }
}

ErrorBoundary.defaultProps = {
  children: null,
  env: null,
  headerMessage: DEFAULT_HEADER_MESSAGE,
}

ErrorBoundary.propTypes = {
  env: PropTypes.string,
  sentryDSN: PropTypes.string,
  headerMessage: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ])
}

export default ErrorBoundary
